import { useEffect, useState } from "react";
import { useI18n } from "../lib/i18n";
import { cn } from "../lib/utils";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Header = () => {
  const { lang, setLang, t } = useI18n();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navItems = [
    { id: "about", label: t.nav.about },
    { id: "gallery", label: t.nav.gallery },
    { id: "reviews", label: t.nav.reviews },
    { id: "contact", label: t.nav.contact },
  ];

  return (
    <header
      data-testid="site-header"
      className={cn(
        "fixed top-0 inset-x-0 z-50 transition-all duration-500",
        scrolled
          ? "bg-white/80 backdrop-blur-xl border-b border-black/5 shadow-sm"
          : "bg-transparent"
      )}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="brand-home"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2 group"
        >
          <span
            className={cn(
              "h-9 w-9 rounded-full grid place-items-center font-black text-[13px] transition-colors",
              scrolled
                ? "bg-[#1A1A1A] text-[#FFB800]"
                : "bg-[#FFB800] text-[#1A1A1A]"
            )}
          >
            R&V
          </span>
          <span
            className={cn(
              "font-extrabold tracking-tight text-sm md:text-base hidden sm:inline transition-colors",
              scrolled ? "text-[#1A1A1A]" : "text-white drop-shadow"
            )}
          >
            R&V VILLA
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <button
              key={item.id}
              data-testid={`nav-${item.id}`}
              onClick={() => scrollTo(item.id)}
              className={cn(
                "px-4 py-2 rounded-full text-sm font-medium transition-colors",
                scrolled
                  ? "text-[#1A1A1A] hover:bg-black/5"
                  : "text-white/95 hover:bg-white/15"
              )}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div
          data-testid="lang-toggle"
          className={cn(
            "relative inline-flex items-center rounded-full p-1 border transition-colors",
            scrolled
              ? "bg-white border-black/10"
              : "bg-white/15 backdrop-blur-md border-white/30"
          )}
        >
          <span
            aria-hidden
            className={cn(
              "absolute top-1 bottom-1 w-[42px] rounded-full bg-[#FFB800] transition-transform duration-300 ease-out",
              lang === "en" ? "translate-x-[42px]" : "translate-x-0"
            )}
            style={{ left: 4 }}
          />
          <button
            data-testid="lang-it"
            onClick={() => setLang("it")}
            className={cn(
              "relative z-10 w-[42px] h-8 text-[12px] font-bold tracking-wider transition-colors",
              lang === "it"
                ? "text-[#1A1A1A]"
                : scrolled
                ? "text-[#1A1A1A]/60"
                : "text-white/80"
            )}
          >
            IT
          </button>
          <button
            data-testid="lang-en"
            onClick={() => setLang("en")}
            className={cn(
              "relative z-10 w-[42px] h-8 text-[12px] font-bold tracking-wider transition-colors",
              lang === "en"
                ? "text-[#1A1A1A]"
                : scrolled
                ? "text-[#1A1A1A]/60"
                : "text-white/80"
            )}
          >
            EN
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
